import Status               from "dashboard/dist/Core/Status";
import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";

// Types
import {
    INTEREST_LOADING,
    INTEREST_LIST, INTEREST_ELEM, INTEREST_CREATE,
} from "Utils/Types";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    position  : 0,
    courses   : [],
    groupinterest   : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate      = DateTime.formatDate(elem.createdTime, "dashes");
    elem.createdDateTime  = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.statusName       = Status.getName(elem.status);
    elem.statusColor      = Status.getColor(elem.status);
    elem.statusClass      = Status.getTextClass(elem.status);
    elem.isActivityString = Utils.toYesNo(elem.isActivity);
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, INTEREST_LIST, INTEREST_ELEM, INTEREST_CREATE)) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case INTEREST_LOADING:
        return {
            ...state,
            loading   : true,
        };

    case INTEREST_LIST:
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : parseList(action.data.list),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case INTEREST_ELEM:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            canEdit   : action.data.canEdit,
            position  : action.data.position,
            courses   : action.data.courses,
            groupinterest   : action.data.groupinterest,
            elem      : parseElem(action.data.elem),
        };

    case INTEREST_CREATE:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            position  : action.data.position,
            courses   : action.data.courses,
            groupinterest   : action.data.groupinterest,
        };

    default:
        return state;
    }
};

export default reducer;
